import React from 'react';
import Menuitem from './Menuitem';
import Bottomheader from '../NewPlayGame/Bottomheader';
import { useSelector } from 'react-redux';

const Menu = () => {

  const activeTheme = useSelector((state) => state.activeTheme)

  return (
    <div className="driving-container" style={{ backgroundImage: `url(${activeTheme.themeActive})`, backgroundSize: "100% 100%", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
      <Menuitem />
      <Bottomheader />
    </div>
  )
}

export default Menu
